import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './utils/analytics';
import { watchInstallPrompt } from './utils/installPrompt';

initAnalytics();

/* 크롬은 페이지가 열리자마자 '홈 화면에 추가' 를 부를 기회를 한 번 던진다.
   React 가 그려진 뒤에 들으면 이미 지나간 뒤라 영영 못 받는다. 그래서
   여기서, 그리기 전에 듣는다. */
watchInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * 서비스워커 등록과 업데이트 반영.
 *
 * 홈 화면에 추가한 PWA 는 앱을 다시 열어도 '재시작' 이 아니라 '재개' 다.
 * 화면을 새로 불러오지 않으므로, 새 버전을 받아놔도 옛 화면이 계속 보인다.
 * 그렇다고 새 버전이 올라오는 즉시 리로드하면
 *   - 구글 로그인에서 돌아오는 중이면 인증이 날아가고
 *   - 메모를 쓰는 중이면 입력이 사라진다.
 *
 * 그래서 리로드를 '앱이 화면 밖으로 나갔다가 돌아오는 순간' 으로 미룬다.
 * 그때는 사용자가 무언가를 하던 중이 아니고, PWA 는 이 전환이 잦다.
 */
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // 첫 설치 때도 controllerchange 가 발생한다. 그때는 리로드하면 안 된다.
  const hadController = !!navigator.serviceWorker.controller;
  let updateReady = false;
  let reloading = false;

  /** 로그인 콜백 도중에는 절대 리로드하지 않는다 */
  const inAuthCallback = () =>
    window.location.hash.includes('access_token') ||
    window.location.hash.includes('error=') ||
    window.location.search.includes('code=');

  const applyUpdateIfSafe = () => {
    if (!updateReady || reloading || inAuthCallback()) return;
    reloading = true;
    window.location.reload();
  };

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        reg.update();
        setInterval(() => reg.update(), 30 * 60 * 1000);

        // 앱으로 돌아올 때마다 새 버전을 확인하고, 준비돼 있으면 그때 반영한다
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState !== 'visible') return;
          reg.update();
          applyUpdateIfSafe();
        });
      })
      .catch((err) => console.log('SW registration failed:', err));
  });

  // 새 서비스워커가 제어권을 넘겨받으면 '준비됨' 으로만 표시하고 기다린다
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) return; // 첫 설치
    updateReady = true;
    // 화면 밖에 있는 동안 교체됐다면 돌아오는 즉시 반영된다
    if (document.visibilityState === 'hidden') return;
    // 보고 있는 중이라면 방해하지 않고, 다음에 돌아올 때 반영한다
  });

  navigator.serviceWorker.addEventListener('message', (e) => {
    if (e.data?.type === 'SW_UPDATED') {
      updateReady = true;
    }
  });
}
